const Pagination = ({ currentPage, perPage, total, onPageChange }) => {
  const totalPages = Math.ceil(total / perPage);

  if (totalPages <= 1) return null;

  return (
    <div className="next-previous-slide">
      <div className="slides-heading">
        <span>
          Showing {(currentPage - 1) * perPage + 1} to{" "}
          {Math.min(currentPage * perPage, total)} out of {total}
        </span>
      </div>

      <div className="slides-button">
        <ul className="d-flex justify-center align-items-center">
          <li>
            <button
              disabled={currentPage === 1}
              onClick={() => onPageChange(currentPage - 1)}
            >
              <i className="fa fa-angle-left" />
            </button>
          </li>
          <li className="d-flex justify-center align-items-center">
            {Array.from({ length: totalPages }).map((_, index) => {
              if (
                index < 2 ||
                index > totalPages - 3 ||
                (index >= currentPage - 2 && index <= currentPage + 1)
              ) {
                return (
                  <button
                    key={index + 1}
                    onClick={() => onPageChange(index + 1)}
                    className={currentPage === index + 1 ? "active-slide" : ""}
                  >
                    {index + 1}
                  </button>
                );
              } else if (index === 2 || index === totalPages - 3) {
                return <span key={index}>...</span>;
              }
              return null;
            })}
          </li>
          <li>
            <button
              disabled={currentPage === totalPages}
              onClick={() => onPageChange(currentPage + 1)}
            >
              <i className="fa fa-angle-right" />
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Pagination;
